<template>
  <div class="fabric-container">
    <div class="d-flex align-items-center">
      <span style="font-size: 15px;font-weight: 600; color: #2B3447">
        {{ $l('INDEX.evg_sku_tab_pane_label_Material') || '辅料构成' }}
      </span>
      <el-divider direction="vertical" v-if="!disabledEdit"></el-divider>
      <div v-if="!disabledEdit">
        <el-button size="mini" class="ml-2" @click="addMaterial">{{
          $l('INDEX.evg_sku_label_add_materials') || '添加辅料'
        }}</el-button>
      </div>
    </div>
    <div class="fabric-list-info__container">
      <div v-for="item in specList" :key="item.evgSkuMaterialCode">
        <MaterialInfo
          :ref="'fabricSpecRef-' + item.evgSkuMaterialCode"
          :evgSkuCode="evgSkuCode"
          :materialInfo="item"
          :disabled="disabled"
          :isFormal="isFormal"
          @delMaterial="delMaterial"
          @editMaterial="editMaterial"
          @openArtWork="openArtWork"
          @editImage="editImage"
        ></MaterialInfo>
      </div>
    </div>
    <MaterialSetting
      v-if="fabricBatchVisible"
      :visible.sync="fabricBatchVisible"
      :disabled="disabledEdit"
      @close="closeFabricBatchSetting"
      @reload="initSpec"
      :evgSkuCode="evgSkuCode"
      :evgSkuMaterialCode.sync="evgSkuMaterialCode"
    ></MaterialSetting>
    <ArtworkDrawer
      v-if="artworkVisible"
      :visible.sync="artworkVisible"
      @close="close"
      :evgSkuCode="evgSkuCode"
      :evgSkuMaterialCode.sync="evgSkuMaterialCode"
    ></ArtworkDrawer>
  </div>
</template>
<script>
import MaterialInfo from './material-info'
import MaterialSetting from './material-setting'
import ArtworkDrawer from '../material/artwork/ArtworkDrawer.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { MaterialInfo, MaterialSetting, ArtworkDrawer },
  props: {
    disabled: { type: Boolean, default: true },
    isFormal: { type: Boolean, default: false },
    evgSkuCode: { type: String, default: '' },
  },
  mixins: [EditLoading],
  data() {
    return {
      specList: [],
      checkSpecList: [],
      fabricBatchVisible: false,
      artworkVisible: false,
      evgSkuMaterialCode: '',
      currentOpenIndex: null,
    }
  },
  computed: {
    disabledEdit() {
      return this.disabled || this.isFormal
    },
  },
  mounted() {
    this.initSpec()
  },
  methods: {
    initSpec() {
      if (!this.evgSkuCode) return
      this.$api
        .ecomEvgSkuMaterialListApi({
          evgSkuCode: this.evgSkuCode,
        })
        .then((res) => {
          this.specList = []
          this.specList = res.body.data
        })
    },
    delMaterial(e) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .ecomEvgSkuMaterialDelApi({
            evgSkuMaterialCode: e.evgSkuMaterialCode,
          })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.initSpec()
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    editMaterial(e) {
      this.fabricBatchVisible = true
      this.evgSkuMaterialCode = e.evgSkuMaterialCode
    },
    addMaterial() {
      this.fabricBatchVisible = true
      this.evgSkuMaterialCode = ''
    },
    openArtWork(e) {
      this.artworkVisible = true
      this.evgSkuMaterialCode = e.evgSkuMaterialCode
    },

    closeFabricBatchSetting() {
      this.fabricBatchVisible = false
    },
    close() {
      this.$refs[
        `fabricSpecRef-${this.evgSkuMaterialCode}`
      ]?.[0]?.reloadArtwork()
    },
    editImage(data) {
      console.log('editImage >>', data)
    },
  },
}
</script>
<style lang="scss" scoped>
.no-data__wrapper {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fabric-list-info__container {
  margin-top: 10px;
}
</style>
